var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EKTable',{attrs:{"items":_vm.employeesList,"columns":_vm.columns,"selectedLabel":"id"},on:{"details":_vm.openEmployeeDetails,"delete-selected":_vm.submitDeleteMultiEmployees},scopedSlots:_vm._u([{key:"items.imageDto",fn:function(ref){
var value = ref.value;
return [_c('b-avatar',{attrs:{"src":value
          ? value.path
            ? value.path.replace(/^/, _vm.$store.getters['app/domainHost'] + '/')
            : ''
          : ''}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }